import React from 'react';
import PropTypes from 'prop-types';

import AddressIcon from '@material-ui/icons/Business';
import EmailIcon from '@material-ui/icons/Email';
import FaxIcon from '@material-ui/icons/PermPhoneMsg';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';

import Icon from '@components/Icon/Icon';

import './CreditorsContact.scss';

const CreditorsContact = ({
  address,
  name,
  title,
}) => (
  <div className="creditors-contact">
    <div className="creditors-contact__title">
      {title}
    </div>
    <div className="creditors-contact__group">
      <Icon>
        <PersonIcon />
      </Icon>
      <div className="creditors-contact__text">
        {name}
      </div>
    </div>
    {address && (
      <React.Fragment>
        <div className="creditors-contact__group">
          <Icon>
            <AddressIcon />
          </Icon>
          <div className="creditors-contact__text">
            <div>
              {address.name},
            </div>
            <div>
              {address.street},
            </div>
            <div>
              {address.city},
            </div>
            <div>
              {address.state} {address.postalcode},
            </div>
            <div>
              {address.country}
            </div>
          </div>
        </div>
        {address.phone && (
          <div className="creditors-contact__group">
            <Icon>
              <PhoneIcon />
            </Icon>
            <div className="creditors-contact__text">
              {address.phone}
            </div>
          </div>
        )}
        {address.email && (
          <div className="creditors-contact__group">
            <Icon>
              <EmailIcon />
            </Icon>
            <div className="creditors-contact__text">
              {address.email}
            </div>
          </div>
        )}
        {address.fax && (
          <div className="creditors-contact__group">
            <Icon>
              <FaxIcon />
            </Icon>
            <div className="creditors-contact__text">
              {address.fax}
            </div>
          </div>
        )}
      </React.Fragment>
    )}
  </div>
);

CreditorsContact.propTypes = {
  address: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string,
    email: PropTypes.string,
    fax: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
    postalcode: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
  }).isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CreditorsContact;



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/ClaimDetails/components/CreditorsContact/CreditorsContact.js